import { Injectable } from '@angular/core';
import * as $ from 'jquery';
@Injectable()
export class AppConfig {
  constructor() { }

  public load() {
    const currentUrl = window.location.href;
    const appName = localStorage.getItem('appName');
    $('body').removeClass();
    if (currentUrl.indexOf('student') !== -1) {
      localStorage.setItem('appLanguage', 'enplaces');
      localStorage.setItem('appName', 'student');
      $('body').addClass('student-compareplaces');
    } else if (appName === 'student') {
      localStorage.setItem('appLanguage', 'enplaces');
      localStorage.setItem('appName', 'student');
      $('body').addClass('student-compareplaces');
    } else {
      localStorage.setItem('appLanguage', 'es');
      localStorage.setItem('appName', 'eeh');
      $('body').addClass('eeh-woa');
    }
  }
}
